import React, { Component } from "react";
import { defaultOptionsStyle } from "../../../styled/details/stylesSelect";
import { FONT_WEIGHTS } from "../../../../_utils/constants";
import { findIndex } from "lodash";
import { getFont, getVariantName } from "../../../../_utils/common";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TldrChakraSelect from "../../../common/TldrChakraSelect";

class TLDRFontWeight extends Component {
  render() {
    let { fonts, fontFamily, fontWeight, rightsidebar, t } = this.props;
    let fontInfo = getFont(fonts, fontFamily);
    let variants = fontInfo?.payload?.variants ?? [];

    // Filter variant which doesn't have italic
    variants = variants.filter(
      (variant, index) => !variant.toString().includes("italic")
    );

    let fontWeightOptions = variants.map((variant, index) => {
      let predfined = FONT_WEIGHTS[variant];

      return {
        value: variant,
        label:
          predfined?.label ||
          `${predfined?.fontWeight || getVariantName(fontInfo, variant)}`,
        family: fontFamily,
        weight: predfined?.fontWeight || Number(variant),
      };
    });

    let valueIndex = findIndex(fontWeightOptions, {
      weight: Number(fontWeight),
    });

    return (
      <>
        <TldrChakraSelect
          value={
            valueIndex > -1
              ? fontWeightOptions[valueIndex]
              : { label: t("fonts.font_weight") }
          }
          onChange={this.onChange}
          options={fontWeightOptions}
          chakraStyles={defaultOptionsStyle}
          placeholder={t("fonts.font_weight")}
          isDisabled={variants.length === 0 || !variants}
          menuPosition={
            this.props.isMobileView && !rightsidebar.isActionPanelOpen
              ? "fixed"
              : ""
          }
        />
      </>
    );
  }

  onChange = (selected) => {
    this.props.onFontWeightChange(selected.weight);
  };
}

TLDRFontWeight.propTypes = {};

TLDRFontWeight.defaultProps = {
  fontWeight: 400,
};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRFontWeight)
);
